/** The user manual's sections, in order. Ids are linked from the tab bar (tabs.ts `help`): rename one there too. */
export const CONTENTS: [string, string][] = [
  ['start-here', 'Start here'],
  ['writers', 'Writers and editors'],
  ['life', 'The life of a piece'],
  ['desk', 'The Desk'],
  ['weekly', 'The weekly package'],
  ['ideas', 'Ideas'],
  ['start', 'Starting a piece'],
  ['import', 'Importing a file'],
  ['from-wordpress', 'From WordPress'],
  ['sources', 'Checking the sources'],
  ['pieces', 'The Pieces list'],
  ['editing', 'Editing a piece'],
  ['panel', 'The side panel'],
  ['revise', 'Revise, start again, set aside'],
  ['versions', 'Making a version'],
  ['approve', 'Approving'],
  ['publish', 'Publishing'],
  ['schedule', 'Schedule'],
  ['live', 'Live'],
  ['readers', 'Reading the numbers'],
  ['social', 'Social'],
  ['topics', 'Topic pages'],
  ['tracks', 'Track Finder'],
  ['settings', 'Settings'],
  ['faq', 'Questions and problems'],
]
